import React from 'react';
import './Footer.css';
import footer_logo from '../Assets/logo.png';
import instagram_icon from '../Assets/instagram_icon.png';
import facebook_icon from '../Assets/facebook_icon.png';
import whatsapp_icon from '../Assets/whatsapp_icon.png';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate(); // Replaces useHistory in React Router v6

    const handleLogout = () => {
        localStorage.removeItem('auth-token');
        navigate('/'); // Redirect to home after logout
    };

    return (
        <div className="footer">
            <div className="footer-image" />

            <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/297a21d4313dd1c2eba6dbbcbeebb211914a561d8c1cf03e39835ddf3c124ca9?placeholderIfAbsent=true&apiKey=6cce6b0f88eb4bbbab8a26fbbd173e15"
                alt="Hero banner showcasing main content"
                className="footer-banner"
            />

            <div className="footer-main">
                {/* Contact Us Section */}
                <div className="contact-us">
                <h2>Contact Us</h2>

                {/* Phone number card */}
                <div className="contact-item-card">
                    <div className="contact-item">
                        <a href="tel:+14038898182">403 889 8182</a>
                    </div>
                </div>

                {/* Email card */}
                <div className="contact-item-card">
                    <div className="contact-item">
                        <a href="mailto:email@email.com">email@email.com</a>
                    </div>
                </div>
            </div>


                {/* Divider */}
                <div className="footer-divider"></div>

                {/* Follow Us Section */}
                <div className="follow-us">
                    <h2>Follow Us</h2>
                    <div className="follow-icons">
                        {/* Facebook Card */}
                        <div className="follow-item-card">
                            <div className="follow-item">
                                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                                    <img src={facebook_icon} alt="Facebook" />
                                </a>
                            </div>
                        </div>

                        {/* Instagram Card */}
                        <div className="follow-item-card">
                            <div className="follow-item">
                                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                                    <img src={instagram_icon} alt="Instagram" />
                                </a>
                            </div>
                        </div>

                        {/* Twitter Card */}
                        <div className="follow-item-card">
                            <div className="follow-item">
                                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                                    <img src={whatsapp_icon} alt="Twitter" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-image2">
                <div className="footer-copyright">
                    <p>Copyright @ 2025 - All Rights Reserved.</p>
                    {/* Login/Logout Button */}
                    <div className="login-btn-container">
                        {localStorage.getItem('auth-token') ? (
                            <button onClick={handleLogout} className="login-btn">
                                Logout
                            </button>
                        ) : (
                            <Link to="/login" className="login-btn">
                                Login
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
